import { render, staticRenderFns } from "./RecruitmentPayoutDetailsV2.vue?vue&type=template&id=163c6398"
import script from "./RecruitmentPayoutDetailsV2.vue?vue&type=script&lang=js"
export * from "./RecruitmentPayoutDetailsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports